import { NINJA_AGENT_TITLE, NINJA_AUTO_MODELS } from 'src/constants';
import { useMemo } from 'react';
import { Message, MessageSkill } from 'src/types';

const SKILL_EXCEPTIONS = [MessageSkill.FILE];

interface CustomModelName {
  customModelName: string | null;
}

export const useCustomNinjaModelName = ({
  modelIds,
  messageSkill,
}: {
  modelIds: Message['model_ids'];
  messageSkill: MessageSkill | null;
}): CustomModelName => {
  const customModelName = useMemo(() => {
    const currentModelId = modelIds?.[0];

    if (
      !currentModelId &&
      messageSkill &&
      SKILL_EXCEPTIONS.includes(messageSkill)
    ) {
      return NINJA_AGENT_TITLE;
    }

    return currentModelId && NINJA_AUTO_MODELS.includes(currentModelId)
      ? NINJA_AGENT_TITLE
      : null;
  }, [modelIds, messageSkill]);

  return { customModelName };
};
